<template>
    <div v-if="paymentModal">
        <v-dialog  v-model="paymentModal"
        max-width="500px" content-class="payment">
            <v-card>
                <div class="modal-header">
                    <h4 class="modal-headline">{{ membership.name }}</h4>
                    <div class="tools">
                        <v-btn icon @click="paymentModal = false"><v-icon>mdi-close</v-icon></v-btn>
                    </div>
                </div>
                <v-card-text>
                    <v-container>
                            <p> {{ $page.props.lang.period || "Period"}} : {{ membership.start_date  | formatDate}} - {{ membership.end_date | formatDate}}</p>
                            <v-spacer></v-spacer>
                            <p> {{ $page.props.lang.price || "Price"}} : {{ membership.price }} <span class="table-currency">{{ $page.props.organization.settings.currency }}</span> </p>
                            <v-row>
                                <v-col cols="8">    
                                    <label class="custom-label">{{ $page.props.lang.payment_method||'Payment method'}}</label>     
                                    <v-select v-model="payment.payment_type_id" 
                                    :items="payment_types" item-text="name" item-value="id" outlined dense
                                    :hide-details="!responseErrors.payment_type_id"
                                    :error-messages="responseErrors.payment_type_id" @focus="responseErrors.payment_type_id=''"></v-select>     
                                </v-col> 
                                <v-col cols="4">
                                    <v-btn @click="assignPayment" :loading="saving" color="primary" class="mt-6 ml-4">{{ $page.props.lang.markPayed || "Mark payed" }}</v-btn>
                                </v-col>    
                            </v-row>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>

         
    </div>
</template>

<script>
import EventBus from '@/js/eventbus'
export default {
    props: {
        open: Boolean,
        membership: Object,
        payment_types: Array
    },
    data(){
        return {
            messageObjects: [],
            responseErrors: {},
            saving: false,
            payment:{
                id: this.membership.id,
                payment_type_id: null 
            }
        }
    },
    computed: {
        paymentModal: {
            get: function() {
                 
                
                return this.open
            },
            set: function() {
                this.$emit('close')
                return false
            }
        }
    },

    methods: {
      getMembershipPeriod(){
         
      },

      assignPayment(){
          this.saving = true;
          axios.post('/backoffice/members/assignPayment', this.payment)
                .then(response => {
                    var color = "error";
                    this.saving = false;

                    
                })
                .catch(error => {
                    this.saving = false;
                    EventBus.$emit('SHOW_NOTIFICATION', {
                        message: error.response.data.message,
                        color: 'error',
                        timeout: 5000
                    });
                    this.responseErrors = error.response.data.errors
                })
      }
    }
}
</script>

